export const appLogger = (message?: any, ...optionalParams: any[]) => {
  if (import.meta.env.VITE_ENV_NAME !== 'production') {
    console.log(message, ...optionalParams);
  }
};
